import { render, staticRenderFns } from "./EspVotingStar.vue?vue&type=template&id=7f38a7d2&scoped=true&"
import script from "./EspVotingStar.vue?vue&type=script&lang=js&"
export * from "./EspVotingStar.vue?vue&type=script&lang=js&"
import style0 from "./EspVotingStar.vue?vue&type=style&index=0&id=7f38a7d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f38a7d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRating } from 'vuetify/lib/components/VRating';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRating,VRow})
